import React, { useState, useEffect } from 'react';
import { useQuery } from '@apollo/react-hooks';
import { loader } from 'graphql.macro';
import { Field } from 'react-final-form';
import { Select, TextField } from 'final-form-material-ui';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import MenuItem from '@material-ui/core/MenuItem';
import Cookies from 'js-cookie';
import useTranslation from '../../../hooks/useTranslation';
import dropdownOptions from '../../../utilities/constants';
import skipEgmOptions from '../../../utilities/skipEgmOptions';
import DownshiftMultiple from './downshift-multiple';
import FilterDialog from '../filter-dialog';

const RECORD_LIST = loader('../../../graphql/schema/search/queries/record-list.graphql');
const FUNDED_BY_LIST = loader('../../../graphql/schema/search/queries/funded-by-list.graphql');

const CustomSelect = ({
  input, meta, render, children, ...restProps
}) => (
  <select {...input} {...restProps}>
    {(render && render()) || children}
  </select>
);

const Condition = (props) => {
  const { when, is, children } = props;

  return (
    <Field name={when} subscription={{ value: true }}>
      { ({ input: { value } }) => (value === is ? children : null) }
    </Field>
  );
};

const InitialFilters = (props) => {
  const { classes, name, values } = props;
  const { t } = useTranslation();
  const [menuOption, setMenuOption] = useState('');
  const [productList, setProductList] = useState(false);
  const [fundingByList, setFundingByList] = useState(false);
  const [initialBoxValue, setInitialBoxValue] = useState(true);
  const [firstRender, setfirstRenderValue] = useState(true);

  const [otherList, setOtherList] = useState(true);
  const [textBox, setTextBox] = useState(false);
  const [textBoxValue, setTextBoxValue] = useState('');
  const originalOption = dropdownOptions.find((opt) => t(opt.transKey) === menuOption);
  const englishMenuOption = originalOption ? originalOption.value : menuOption;

  const menuOptionValue = englishMenuOption && englishMenuOption
    .replace('Region', 'Continent')
    .replace('Sector', 'Sectors')
    .replace('Author', 'Author Name')
    .replace('Interventions', 'Findings Intervention List')
    .replace('Outcomes', 'Findings Outcomes List');

  const { data } = useQuery(RECORD_LIST, {
    variables: { data: (menuOptionValue && menuOptionValue) || '' },
    skip: !menuOptionValue || menuOptionValue.length === 0,
    onCompleted() {
      setInitialBoxValue(false);

      const arrYearPublication = [];
      const arrSplYearPublication = [];
      if (data && data.recordList.name.toLowerCase() === 'year of publication') {
        data.recordList.values.forEach((value) => {
          if (value.value === '9999') {
            arrSplYearPublication[value.value] = value;
          } else {
            arrYearPublication[value.value] = value;
          }
        });

        if (arrYearPublication.length > 0) {
          arrYearPublication.sort((a, b) => ((a.value < b.value) ? 1 : -1));
        }

        if (arrSplYearPublication.length > 0) {
          arrYearPublication.push(arrSplYearPublication[9999]);
        }

        data.recordList.values = arrYearPublication;
      }
    },
    fetchPolicy: 'network-only',
  });

  const { data: fundedData } = useQuery(FUNDED_BY_LIST, {
    variables: { data: 'Funded By List' },
    skip: !fundingByList,
    onCompleted() {
      setInitialBoxValue(false);
    },
    fetchPolicy: 'network-only',
  });

  useEffect(() => {
    const path = window.location.pathname;

    if (path !== '/' && firstRender) {
      const value = values && values.initialFilter.type;
      setfirstRenderValue(false);

      const actions = {
        [t('advSearchStudyType')]: () => {
          setTextBox(false);
          setOtherList(false);
          setProductList(true);
          setFundingByList(false);
          setInitialBoxValue(false);
        },
        [t('advSearchFundedBy')]: () => {
          setTextBox(false);
          setOtherList(false);
          setProductList(false);
          setFundingByList(true);
          setInitialBoxValue(false);
        },
        [t('advSearchTitle')]: () => {
          setTextBox(true);
          setTextBoxValue(value);
          setOtherList(false);
          setProductList(false);
          setFundingByList(false);
          setInitialBoxValue(false);
        },
        [t('advSearchAuthor')]: () => {
          setTextBox(true);
          setTextBoxValue(value);
          setOtherList(false);
          setProductList(false);
          setFundingByList(false);
          setInitialBoxValue(false);
        },
        [t('advSearchAbstract')]: () => {
          setTextBox(true);
          setTextBoxValue(value);
          setOtherList(false);
          setProductList(false);
          setFundingByList(false);
          setInitialBoxValue(false);
        },
        [t('advSearchEvalDesign')]: () => {
          setTextBox(false);
          setMenuOption(value);
          setOtherList(true);
          setProductList(false);
          setFundingByList(false);
          setInitialBoxValue(false);
        },
        [t('advSearchEvalMethod')]: () => {
          setTextBox(false);
          setMenuOption(value);
          setOtherList(true);
          setProductList(false);
          setFundingByList(false);
          setInitialBoxValue(false);
        },
        [t('advSearchPubType')]: () => {
          setTextBox(false);
          setTextBoxValue(value);
          setMenuOption(value);
          setOtherList(true);
          setProductList(false);
          setFundingByList(false);
          setInitialBoxValue(true);
        },
        [t('advSearchKeywords')]: () => {
          setTextBox(true);
          setTextBoxValue(value);
          setOtherList(false);
          setProductList(false);
          setFundingByList(false);
          setInitialBoxValue(false);
        },
        default: () => {
          setTextBox(false);
          setMenuOption(value);
          setOtherList(true);
          setProductList(false);
          setFundingByList(false);
          setInitialBoxValue(true);
        },
      };

      (actions[value] || actions.default)();
    }
  }, [firstRender, values, t]);

  const handleMenu = (event) => {
    Cookies.set('filterDialogShowFirstTime', 'AdvSearch', { expires: '' });
    const { target: { value } } = event;

    const actions = {
      [t('advSearchStudyType')]: () => {
        setTextBox(false);
        setOtherList(false);
        setProductList(true);
        setFundingByList(false);
        setInitialBoxValue(false);
      },
      [t('advSearchFundedBy')]: () => {
        setTextBox(false);
        setOtherList(false);
        setProductList(false);
        setFundingByList(true);
        setInitialBoxValue(false);
      },
      [t('advSearchTitle')]: () => {
        setTextBox(true);
        setTextBoxValue(value);
        setOtherList(false);
        setProductList(false);
        setFundingByList(false);
        setInitialBoxValue(false);
      },
      [t('advSearchAuthor')]: () => {
        setTextBox(true);
        setTextBoxValue(value);
        setOtherList(false);
        setProductList(false);
        setFundingByList(false);
        setInitialBoxValue(false);
      },
      [t('advSearchAbstract')]: () => {
        setTextBox(true);
        setTextBoxValue(value);
        setOtherList(false);
        setProductList(false);
        setFundingByList(false);
        setInitialBoxValue(false);
      },
      [t('advSearchEvalDesign')]: () => {
        setTextBox(false);
        setTextBoxValue(value);
        setMenuOption(value);
        setOtherList(true);
        setProductList(false);
        setFundingByList(false);
        setInitialBoxValue(true);
      },
      [t('advSearchEvalMethod')]: () => {
        setTextBox(false);
        setTextBoxValue(value);
        setMenuOption(value);
        setOtherList(true);
        setProductList(false);
        setFundingByList(false);
        setInitialBoxValue(true);
      },
      [t('advSearchPubType')]: () => {
        setTextBox(false);
        setTextBoxValue(value);
        setMenuOption(value);
        setOtherList(true);
        setProductList(false);
        setFundingByList(false);
        setInitialBoxValue(true);
      },
      [t('advSearchKeywords')]: () => {
        setTextBox(true);
        setTextBoxValue(value);
        setOtherList(false);
        setProductList(false);
        setFundingByList(false);
        setInitialBoxValue(false);
      },
      default: () => {
        setTextBox(false);
        setMenuOption(value);
        setOtherList(true);
        setProductList(false);
        setFundingByList(false);
        setInitialBoxValue(true);
      },
    };

    (actions[value] || actions.default)();
  };

  return (
    <div className={classes.initialFilterRow}>
      <Field
        name={`${name}.type`}
        component={Select}
        displayEmpty
        renderValue={(selected) => {
          if (selected.length === 0) {
            return <em>{t('selectOption')}</em>;
          }

          const select = selected.toLowerCase();
          return select.charAt(0).toUpperCase() + select.slice(1);
        }}
        onClick={handleMenu}
        className={classes.initialFilterSelectBox}
      >
        <MenuItem value="Select option">{t('selectOption')}</MenuItem>
        {
          dropdownOptions.map((menu) => <MenuItem key={menu.id} value={t(menu.transKey)}>{t(menu.transKey)}</MenuItem>)
        }
      </Field>

      {initialBoxValue ? (
        <Field
          name={`${name}.value`}
          className={classes.initialFilterTextField}
          autoComplete="off"
          disabled
          component={TextField}
          placeholder={t('advSearchQueryPlaceholder')}
        />
      ) : (
        <React.Fragment>
          {textBox ? (
            <React.Fragment>
              {(textBoxValue === 'Publication type') ? (
                data && (
                  <Field
                    name={`${name}.value`}
                    classes={classes}
                    values={values}
                    suggestions={data}
                    component={DownshiftMultiple}
                  />
                )
              ) : (
                <Field
                  name={`${name}.value`}
                  className={classes.initialFilterTextField}
                  autoComplete="off"
                  defaultValue=""
                  component={TextField}
                  placeholder={t('advSearchQueryPlaceholder')}
                />
              )}
            </React.Fragment>
          ) : (
            <div className={classNames(classes.initialFilterSelectBox, classes.filterBoxSubMenu)}>
              {otherList && (
                <div>
                  <Field
                    name={`${name}.value`}
                    component={CustomSelect}
                  >
                    {(menuOption && menuOption !== 'Select option') && (
                      <option value="Select option">{t('selectOption')}</option>
                    )}
                    {(menuOption && data && data.recordList) && (
                      data.recordList.values.map((value) => {
                        if (skipEgmOptions.indexOf(value.id) === -1) {
                          let optionValue = value.value;
                          if (optionValue.length >= 80) {
                            optionValue = `${optionValue.substring(0, 79)}...`;
                          }
                          return <option key={value.id} title={value.value} value={value.value}>{optionValue}</option>;
                        }
                        return '';
                      })
                    )}
                  </Field>
                </div>
              )}

              {productList && (
                <div>
                  <Field
                    name={`${name}.value`}
                    component={CustomSelect}
                    className={classes.initialFilterSelectBox}
                  >
                    <option value="Select option">{t('selectOption')}</option>
                    <option title={t('impactEvaluationFilter')} value="Impact Evaluation">{t('impactEvaluationFilter')}</option>
                    <option title={t('systematicReviewFilter')} value="Systematic Review">{t('systematicReviewFilter')}</option>
                    <option title={t('evidenceGapMapFilter')} value="Evidence Gap Map">{t('evidenceGapMapFilter')}</option>
                  </Field>
                </div>
              )}

              {fundingByList && (
                <div>
                  <Field
                    name={`${name}.value`}
                    component={CustomSelect}
                    className={classes.initialFilterSelectBox}
                  >
                    <option value="Select option">{t('selectOption')}</option>
                    {(fundedData && fundedData.fundedByList) && (
                      fundedData.fundedByList.funded_by_list.map((value) => {
                        let optionValue = value.value;
                        if (optionValue.length >= 80) {
                          optionValue = `${optionValue.substring(0, 79)}...`;
                        }
                        return <option key={value.id} title={value.value} value={value.value}>{optionValue}</option>;
                      })
                    )}
                  </Field>
                </div>
              )}
            </div>
          )}
        </React.Fragment>
      )}

      <Condition when={`${name}.type`} is="Menu item">
        <Field
          name={`${name}.type`}
          component={Select}
          onClick={handleMenu}
          defaultValue="Select option"
        >
          <MenuItem value="Select option">{t('selectOption')}</MenuItem>
          {dropdownOptions.map((menu) => <MenuItem key={menu.id} value={t(menu.transKey)}>{t(menu.transKey)}</MenuItem>)}
        </Field>
      </Condition>

      <Condition when={`${name}.value`} is="Submenu item">
        <Field
          name={`${name}.value`}
          component={CustomSelect}
        >
          <option value="Select option">{t('selectOption')}</option>
          {(data && data.recordList) && (
            data.recordList.values.map((value) => {
              if (skipEgmOptions.indexOf(value.id) === -1) {
                let optionValue = value.value;
                if (optionValue.length >= 80) {
                  optionValue = `${optionValue.substring(0, 79)}...`;
                }
                return <MenuItem key={value.id} title={value.value} value={value.value}>{optionValue}</MenuItem>;
              }
              return '';
            })
          )}
        </Field>
      </Condition>
      <FilterDialog
        buttonText="Ok"
        popupType="AdvSearch"
      />
    </div>
  );
};

CustomSelect.defaultProps = {
  render: () => {},
};

CustomSelect.propTypes = {
  children: PropTypes.arrayOf(PropTypes.node).isRequired,
  input: PropTypes.object.isRequired,
  render: PropTypes.func,
  meta: PropTypes.object.isRequired,
};

Condition.propTypes = {
  when: PropTypes.string.isRequired,
  is: PropTypes.string.isRequired,
  children: PropTypes.object.isRequired,
};

InitialFilters.propTypes = {
  classes: PropTypes.object.isRequired,
  name: PropTypes.string.isRequired,
  values: PropTypes.object.isRequired,
};

export default InitialFilters;
